export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40b15b33c10c7c313fa02e6b561220f13636e76b7c&name=revalidateCommunity!'